export interface SessionWatcherOptions {
  getExpiry?: () => number | null;
  onExpire: () => void;
  checkIntervalMs?: number;
}

/**
 * Lightweight session watcher.
 * - Optionally checks a local expiry timestamp.
 * - Also acts as a safety fallback on top of existing axios 401 handling.
 */
export function startSessionWatcher({
  getExpiry,
  onExpire,
  checkIntervalMs = 60_000,
}: SessionWatcherOptions) {
  if (typeof onExpire !== "function") {
    throw new Error("startSessionWatcher: onExpire is required");
  }

  let expired = false;
  let intervalId: number | null = null;

  const clearIntervalSafe = () => {
    if (intervalId !== null) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
  };

  const checkOnce = () => {
    if (expired || !getExpiry) return;

    const expiry = getExpiry();
    if (!expiry) return;

    if (Date.now() >= expiry) {
      expired = true;
      clearIntervalSafe();
      try {
        onExpire();
      } catch (e) {
        console.error("startSessionWatcher onExpire error", e);
      }
    }
  };

  if (getExpiry) {
    intervalId = window.setInterval(checkOnce, checkIntervalMs);
    checkOnce();
  }

  return () => {
    clearIntervalSafe();
  };
}

